import MediaPlanAssetsCard from './MediaPlanAssetsCard';

export default MediaPlanAssetsCard;
